export var SitemapTemplates;

(function (SitemapTemplates) {
  SitemapTemplates["CATEGORY"] = "CATEGORY";
  SitemapTemplates["GENERAL"] = "GENERAL";
  SitemapTemplates["IMAGE"] = "IMAGE";
  SitemapTemplates["THREAD"] = "THREAD";
  SitemapTemplates["VIDEO"] = "VIDEO";
})(SitemapTemplates || (SitemapTemplates = {}));